import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Glass extends Component {

  constructor(props) {
    super(props);
    this.getSelectedGlass = this.getSelectedGlass.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedGlass !== this.props.selectedGlass || prevProps.frameFullDimension !== this.props.frameFullDimension || prevProps.selectedTopMatValueInCM !== this.props.selectedTopMatValueInCM || prevProps.selectedMiddleMatValueInCM !== this.props.selectedMiddleMatValueInCM || prevProps.selectedBottomMatValueInCM !== this.props.selectedBottomMatValueInCM || prevProps.selectedMatSize !== this.props.selectedMatSize ) {
      this.getSelectedGlass();
  	}
	}

  getSelectedGlass = () => {
   	const {glasses, selectedGlass, selectedMatSize, frameFullDimension} = this.props;

    var topMatWidth = 0;
    var middleMatWidth = 0;
    var bottomMatWidth = 0;

    if (parseFloat(selectedMatSize) !== 0) {
      topMatWidth = this.props.selectedTopMatValueInCM
    }

    if (parseFloat(selectedMatSize) === 2 || parseFloat(selectedMatSize) === 3) {
      middleMatWidth = this.props.selectedMiddleMatValueInCM
    }

    if (parseFloat(selectedMatSize) === 3) {
      bottomMatWidth = this.props.selectedBottomMatValueInCM
    }

		if (glasses.size > 0 && selectedGlass !== null) {
			glasses.filter( ( glass ) =>
        parseFloat(selectedGlass) === glass.get('id')
      ).map( ( glass ) =>
  			this.props.dispatch({
  				type: 'SET_STATE',
  				state: {
  					glassTotal: ( parseFloat(glass.getIn(['acf', 'price'])) * ( frameFullDimension + ( (parseFloat(topMatWidth) * 4) + (parseFloat(middleMatWidth) * 4) + (parseFloat(bottomMatWidth)) * 4) ) ).toFixed(2),
  					selectedGlassName: glass.getIn(['title', 'rendered'])
  				}
  			})
      )
    }
  };

	render() {
		const {glassTotal, selectedGlassName} = this.props;
    return (
      <tr> 
  			<th>Glass</th> 
  			<td>{selectedGlassName}</td> 
  			<td>{Constants.Currency + glassTotal}</td> 
      </tr>
    );
	}
}

export default Glass;